export default class ApiError extends Error {

}